export default "__VITE_ASSET__Da7qnH_Y__"